export const ACTION_TYPE = {
  PRICE_RANGE: "PRICE_RANGE",
  CATEGORIES: "CATEGORIES",
  SUBCATEGORIES:"SUBCATEGORIES",
  RATING: "RATING",
  SORT_BY_PRICE: "SORT_BY_PRICE",
  CLEAR_ALL: "CLEAR_ALL",
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  INCREASE_ITEM_QTY:"INCREASE_ITEM_QTY",
  DECREASE_ITEM_QTY: "DECREASE_ITEM_QTY",
  ADD_TO_WISHLIST: "ADD_TO_WISHLIST",
  REMOVE_FROM_WISHLIST: "REMOVE_FROM_WISHLIST",
};